import React from 'react';
import BaseGrid from 'components/atoms/base-grid';
import { Metrics } from '@accuhealth/call-dashboard-ui';
import { Routes } from 'router/routes';
import CallDashboardMetricsPageHeader from 'components/organisms/call-agents-dashboard/page-header';

import s from './styles.module.scss';

const CallAgentsDashboardMetricsPage: React.FC = () => {
  return (
    <BaseGrid className={s.wrapper} rowGap={40}>
      <CallDashboardMetricsPageHeader />
      <Metrics
        agentProfilePath={({ userId }) => Routes.callAgentProfile(userId)}
      />
    </BaseGrid>
  );
};

export default CallAgentsDashboardMetricsPage;
